import { pathOr } from "ramda";
import { GRAPH_URL } from "../../../constants";
import { getAuthorizationHeader } from "./authorization";

export const VideoStatus = {
  PENDING: "pending",
  RETRYING: "retrying",
  FAILED: "failed",
  DONE: "done",
};

const createVideoOrderQuery = `
  mutation CreateVideoOrder(
    $composition: JSON!
    $features: JSON
    $framesPerScenePart: String
    $templateId: String!
    $footages: [String]
    $stripe: StripeInput
  ) {
    createVideoOrder(
      composition: $composition
      features: $features
      templateId: $templateId
      framesPerScenePart: $framesPerScenePart
      footages: $footages
      stripe: $stripe
    ) {
      id
      status
      key
      video {
        uri
      }
    }
  }
`;

export const createVideoOrder = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      ...getAuthorizationHeader(),
    },
    body: JSON.stringify({ query: createVideoOrderQuery, variables }),
  })
    .then(res => res.json())
    .then(res => {
      const videoOrderId = pathOr(null, ["data", "createVideoOrder", "id"])(res);
      const videoOrderStatus = pathOr(null, ["data", "createVideoOrder", "status"])(res);
      const videoOrderVideoUrl = pathOr(null, ["data", "createVideoOrder", "video", "uri"])(res);
      return {
        id: videoOrderId,
        status: videoOrderStatus,
        videoUrl: videoOrderVideoUrl,
      };
    });

const videoOrderQuery = `
query VideoOrder($id: ID!) { 
  videoOrder(id: $id) {
    id
    status
    key
    video {
      uri
    }
  }
}
`;

export const getVideoOrder = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      ...getAuthorizationHeader(),
    },
    body: JSON.stringify({ query: videoOrderQuery, variables }),
  })
    .then(res => res.json())
    .then(res => {
      const videoOrderId = pathOr(null, ["data", "videoOrder", "id"])(res);
      const videoOrderStatus = pathOr(null, ["data", "videoOrder", "status"])(res);
      const videoOrderVideoUrl = pathOr(null, ["data", "videoOrder", "video", "uri"])(res);
      return {
        id: videoOrderId,
        status: videoOrderStatus,
        videoUrl: videoOrderVideoUrl,
      };
    });
